module.exports = __webpack_public_path__ + "static/img/kk_gray.1d6019a2.png";